import React from "react";
import "moment/locale/ja";
import moment from "moment";

import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";

const DATE_FMT = "YYYYMMDDHHmm";

class CustomInput extends React.PureComponent {
  render() {
    const { onClick, value, hideTime, disabled } = this.props;

    return (
      <button className="custom-input" onClick={onClick} style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0, 0.87)', width: hideTime ? '145px' : '' }}>
        {hideTime && (!value || value.trim() === "") ? "YYYY/MM/DD" : value}
      </button>
    );
  }
}

const DatePicker = props => {
  return (
    <ReactDatePicker
      customInput={<CustomInput hideTime={props.hideTime} disabled={props.disabled} />}
      showTimeSelect={!props.hideTime}
      disabledKeyboardNavigation
      disabled={props.disabled}
      dateFormat={props.hideTime ? "LL" : "LLL"}
      timeFormat={props.hideTime ? undefined : "HH:mm"}
      locale="ja"
      timeCaption={props.hideTime ? undefined : "時間"}
      selected={
        props.selectedDate ? moment(props.selectedDate, DATE_FMT) : null
      }
      onChange={date => date && props.onChange(date.format(DATE_FMT))}
    />
  );
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/uis/Datepicker/index.jsx